let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e86yh")).then(() => parcelRequire('6CcyL'));